import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=39484a98&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=39484a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39484a98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39484a98')) {
      api.createRecord('39484a98', component.options)
    } else {
      api.reload('39484a98', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=39484a98&scoped=true&", function () {
      api.rerender('39484a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/Comment.vue"
export default component.exports